var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2326_34162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.9 8.1 27.5 15 27.5C21.9 27.5 27.5 21.9 27.5 15C27.5 8.1 21.9 2.5 15 2.5ZM15 25C9.4875 25 5 20.5125 5 15C5 9.4875 9.4875 5 15 5C20.5125 5 25 9.4875 25 15C25 20.5125 20.5125 25 15 25ZM15.3875 13.925C13.175 13.3625 12.4625 12.75 12.4625 11.8375C12.4625 10.7875 13.45 10.05 15.0875 10.05C16.8125 10.05 17.4625 10.875 17.5125 12.1H19.65C19.5875 10.425 18.5625 8.8875 16.5375 8.3875V6.25H13.625V8.3625C11.7375 8.7625 10.225 9.9875 10.225 11.875C10.225 14.1125 12.0875 15.2375 14.8 15.8875C17.2375 16.4625 17.725 17.325 17.725 18.225C17.725 18.8875 17.2375 19.9625 15.1 19.9625C13.1 19.9625 12.3125 19.0625 12.2 17.9125H10.05C10.175 20.0375 11.75 21.2375 13.625 21.625V23.75H16.55V21.6625C18.45 21.3 19.95 20.2125 19.9625 18.2C19.95 15.45 17.5875 14.5 15.3875 13.925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2326_34162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmount);
export default __webpack_public_path__ + "static/media/amount.bc4d1d36de5bd70ea133252da90c29e4.svg";
export { ForwardRef as ReactComponent };